
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6wI7U", function(module, exports) {

$parcel$export(module.exports, "JiraLossAversionExperiment", () => (parcelRequire("d7mmo")).JiraLossAversionExperiment);

var $d7mmo = parcelRequire("d7mmo");

});
parcelRegister("d7mmo", function(module, exports) {

$parcel$export(module.exports, "JiraLossAversionExperiment", () => $2096677e4ef89c9d$export$2df1ad55126ecabc);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $eI5EY = parcelRequire("eI5EY");

var $5UdbT = parcelRequire("5UdbT");

var $jQeWf = parcelRequire("jQeWf");
const $2096677e4ef89c9d$export$1cec38cf54975982 = ()=>{
    // AA experiment
    const aaExperimentIsEnabled = (0, $eI5EY.fg)('jira_loss_aversion_standard_gate_aa');
    // This function should fire all necessary exposure events for AA experiment
    (0, $5UdbT.useJiraLossAversionAAExperiment)({
        isExperimentEnabled: aaExperimentIsEnabled,
        extraAnalytics: {}
    });
    // AB experiment
    const abExperimentIsEnabled = (0, $eI5EY.fg)('jira_loss_aversion_standard_gate_ab');
    // TODO: use cohort value?
    const { renderTreatment: renderTreatment } = (0, $5UdbT.useJiraLossAversionABExperiment)({
        isExperimentEnabled: abExperimentIsEnabled,
        extraAnalytics: {}
    });
    if (renderTreatment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQeWf.JiraLossAversionModal), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $2096677e4ef89c9d$export$2df1ad55126ecabc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jiraLossAversionExperiment",
        packageName: "jiraLossAversion",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2096677e4ef89c9d$export$1cec38cf54975982, null));

});
parcelRegister("5UdbT", function(module, exports) {

$parcel$export(module.exports, "useJiraLossAversionABExperiment", () => $74aceb343d1cb8d2$export$793c69f8a4d1e05);
$parcel$export(module.exports, "useJiraLossAversionAAExperiment", () => $74aceb343d1cb8d2$export$2aef6eaacb8e2488);

var $eUqFw = parcelRequire("eUqFw");


var $9Z2je = parcelRequire("9Z2je");

var $fi8kw = parcelRequire("fi8kw");

var $e84zd = parcelRequire("e84zd");

var $dGcKA = parcelRequire("dGcKA");

var $2pc1v = parcelRequire("2pc1v");

var $haZiZ = parcelRequire("haZiZ");
const $74aceb343d1cb8d2$var$useExperiment = ({ isExperimentEnabled: isExperimentEnabled, extraAnalytics: extraAnalytics, experimentName: experimentName })=>{
    const { isEligible: isEligible, isUrgent: isUrgent } = (0, $9Z2je.useExperimentEligibility)(experimentName);
    const { trialDaysLeft: trialDaysLeft } = (0, $2pc1v.useTrialDetails)();
    const { cohort: cohort, isEnrolled: isEnrolled, isTreatment: isTreatment } = (0, $e84zd.useExperimentEnrollment)({
        experimentName: experimentName,
        skip: !isExperimentEnabled
    });
    const shouldTryShowExperiment = isExperimentEnabled && isEnrolled && isEligible;
    const { canShowExperiment: canShowExperiment } = (0, $fi8kw.useCanShowExperiment)({
        skip: !shouldTryShowExperiment
    });
    const { fireExposureEvents: fireExposureEvents } = (0, $dGcKA.useFireExposureEvents)({
        skip: !canShowExperiment,
        experimentName: experimentName,
        extraAnalytics: {
            ...extraAnalytics,
            isUrgent: isUrgent,
            trialDaysLeft: trialDaysLeft
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        // this is a no-op if skip condition passed to useFireExposureEvents is true
        fireExposureEvents();
    }, [
        fireExposureEvents
    ]);
    if (!canShowExperiment) return {
        cohort: cohort,
        renderTreatment: false
    };
    (0, $haZiZ.setHasSeenModal)(experimentName, isUrgent);
    return {
        cohort: cohort,
        renderTreatment: isTreatment
    };
};
const $74aceb343d1cb8d2$export$793c69f8a4d1e05 = ({ isExperimentEnabled: isExperimentEnabled, extraAnalytics: extraAnalytics })=>$74aceb343d1cb8d2$var$useExperiment({
        isExperimentEnabled: isExperimentEnabled,
        extraAnalytics: extraAnalytics,
        experimentName: (0, $d08b9e75af3069cb$export$855e843fe464d553)
    });
const $74aceb343d1cb8d2$export$2aef6eaacb8e2488 = ({ isExperimentEnabled: isExperimentEnabled, extraAnalytics: extraAnalytics })=>$74aceb343d1cb8d2$var$useExperiment({
        isExperimentEnabled: isExperimentEnabled,
        extraAnalytics: extraAnalytics,
        experimentName: (0, $d08b9e75af3069cb$export$998e8261e98c7d7d)
    });

});
const $d08b9e75af3069cb$export$998e8261e98c7d7d = 'jira_loss_aversion_standard_aa';
const $d08b9e75af3069cb$export$855e843fe464d553 = 'jira_loss_aversion_standard_ab';

parcelRegister("9Z2je", function(module, exports) {

$parcel$export(module.exports, "useExperimentEligibility", () => $b493e75c1d2e3d98$export$42c0a6ccc8ff1bba);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $6WXNs = parcelRequire("6WXNs");

var $51hbZ = parcelRequire("51hbZ");

var $e84zd = parcelRequire("e84zd");

var $dgipR = parcelRequire("dgipR");

var $2pc1v = parcelRequire("2pc1v");
const $b493e75c1d2e3d98$var$isDevtestCohort = (cohort)=>cohort === 'devtesting' || cohort === 'devtesting_urgent';
function $b493e75c1d2e3d98$export$42c0a6ccc8ff1bba(experimentName) {
    const { projectType: projectType } = (0, $dgipR.useProjectType)();
    const { jswEdition: jswEdition, billingSourceSystem: billingSourceSystem, trialDaysLeft: trialDaysLeft, isInTrial: isInTrial } = (0, $2pc1v.useTrialDetails)();
    // We include this for our devtesting cohorts. This is not needed for production and should be removed.
    const { cohort: cohort } = (0, $e84zd.useExperimentEnrollment)({
        experimentName: experimentName,
        skip: false
    });
    const isInDevtestCohort = $b493e75c1d2e3d98$var$isDevtestCohort(cohort);
    // Note that a user can be urgent even if they are not eligible
    // It only means that they're in the last few days of a trial
    const isUrgent = isInDevtestCohort ? cohort === 'devtesting_urgent' : isInTrial && !!trialDaysLeft && trialDaysLeft <= 4;
    // we wrap this in a useMemo to avoid rerendering and recalculating the user as ineligible
    // due to having just seen the modal for the first time
    const hasSeenModal = (0, $eUqFw.useMemo)(()=>(0, $51hbZ.getHasSeenModal)(experimentName, isUrgent).hasSeenModal, [
        experimentName,
        isUrgent
    ]);
    const isEligible = projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && jswEdition === (0, $6WXNs.STANDARD_EDITION) && billingSourceSystem === 'CCP' && // on day 7 there are 8 days left of the trial so this targets days 7 - 14
    // note that for the devtesting cohort we don't even need to be in a trial to be eligible
    (!isInDevtestCohort ? isInTrial && !!trialDaysLeft && trialDaysLeft <= 8 : true) && !hasSeenModal;
    return {
        isEligible: isEligible,
        isUrgent: isUrgent
    };
}

});
parcelRegister("51hbZ", function(module, exports) {

$parcel$export(module.exports, "getHasSeenModal", () => $b0331195865d3e5f$export$9b92cc6b9a20fe8e);


var $8bpps = parcelRequire("8bpps");
function $b0331195865d3e5f$export$9b92cc6b9a20fe8e(expermientName, isUrgent) {
    const isAA = expermientName === (0, $d08b9e75af3069cb$export$998e8261e98c7d7d);
    if (isUrgent) return {
        hasSeenModal: isAA ? (0, $8bpps.getHasSeenUrgentModalAA)() : (0, $8bpps.getHasSeenUrgentModalAB)()
    };
    return {
        hasSeenModal: isAA ? (0, $8bpps.getHasSeenFirstModalAA)() : (0, $8bpps.getHasSeenFirstModalAB)()
    };
}

});
parcelRegister("8bpps", function(module, exports) {

$parcel$export(module.exports, "setHasSeenFirstModalAA", () => $56f1beff23eb2685$export$f975a8547e308d3c);
$parcel$export(module.exports, "getHasSeenFirstModalAA", () => $56f1beff23eb2685$export$942862af653abbd);
$parcel$export(module.exports, "setHasSeenUrgentModalAA", () => $56f1beff23eb2685$export$d1618d387d45e1bf);
$parcel$export(module.exports, "getHasSeenUrgentModalAA", () => $56f1beff23eb2685$export$c029ab5532439a30);
$parcel$export(module.exports, "setHasSeenFirstModalAB", () => $56f1beff23eb2685$export$bce05b2cafc179e7);
$parcel$export(module.exports, "getHasSeenFirstModalAB", () => $56f1beff23eb2685$export$b37380d16b5e55e2);
$parcel$export(module.exports, "setHasSeenUrgentModalAB", () => $56f1beff23eb2685$export$e90779b576d8ea9);
$parcel$export(module.exports, "getHasSeenUrgentModalAB", () => $56f1beff23eb2685$export$50208fb710d06b8b);

var $aZaPn = parcelRequire("aZaPn");
const $56f1beff23eb2685$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jira-loss-aversion-standard');
const $56f1beff23eb2685$var$FIRST_MODAL_SEEN_AA = 'jla-first-modal-seen-aa';
const $56f1beff23eb2685$var$URGENT_MODAL_SEEN_AA = 'jla-urgent-modal-seen-aa';
const $56f1beff23eb2685$var$FIRST_MODAL_SEEN_AB = 'jla-first-modal-seen-ab';
const $56f1beff23eb2685$var$URGENT_MODAL_SEEN_AB = 'jla-urgent-modal-seen-ab';
const $56f1beff23eb2685$export$f975a8547e308d3c = ()=>{
    $56f1beff23eb2685$var$localStorage.set($56f1beff23eb2685$var$FIRST_MODAL_SEEN_AA, true);
};
const $56f1beff23eb2685$export$942862af653abbd = ()=>$56f1beff23eb2685$var$localStorage.get($56f1beff23eb2685$var$FIRST_MODAL_SEEN_AA) || false;
const $56f1beff23eb2685$export$d1618d387d45e1bf = ()=>{
    $56f1beff23eb2685$var$localStorage.set($56f1beff23eb2685$var$URGENT_MODAL_SEEN_AA, true);
};
const $56f1beff23eb2685$export$c029ab5532439a30 = ()=>$56f1beff23eb2685$var$localStorage.get($56f1beff23eb2685$var$URGENT_MODAL_SEEN_AA) || false;
const $56f1beff23eb2685$export$bce05b2cafc179e7 = ()=>{
    $56f1beff23eb2685$var$localStorage.set($56f1beff23eb2685$var$FIRST_MODAL_SEEN_AB, true);
};
const $56f1beff23eb2685$export$b37380d16b5e55e2 = ()=>$56f1beff23eb2685$var$localStorage.get($56f1beff23eb2685$var$FIRST_MODAL_SEEN_AB) || false;
const $56f1beff23eb2685$export$e90779b576d8ea9 = ()=>{
    $56f1beff23eb2685$var$localStorage.set($56f1beff23eb2685$var$URGENT_MODAL_SEEN_AB, true);
};
const $56f1beff23eb2685$export$50208fb710d06b8b = ()=>$56f1beff23eb2685$var$localStorage.get($56f1beff23eb2685$var$URGENT_MODAL_SEEN_AB) || false;

});


parcelRegister("e84zd", function(module, exports) {

$parcel$export(module.exports, "useExperimentEnrollment", () => $8b800d1fed2d6949$export$feb34becfec7693);

var $79xbN = parcelRequire("79xbN");

function $8b800d1fed2d6949$var$getCohortValue(experimentName) {
    if (experimentName === (0, $d08b9e75af3069cb$export$998e8261e98c7d7d)) {
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_loss_aversion_standard_aa');
        return expConfig.get('cohort', 'not-enrolled');
    }
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_loss_aversion_standard_ab');
    return expConfig.get('cohort', 'not-enrolled');
}
function $8b800d1fed2d6949$export$feb34becfec7693({ experimentName: experimentName, skip: skip }) {
    if (skip) return {
        cohort: 'not-enrolled',
        isEnrolled: false,
        isTreatment: false
    };
    const cohort = $8b800d1fed2d6949$var$getCohortValue(experimentName);
    const isTreatment = [
        'test',
        'devtesting',
        'devtesting_urgent'
    ].includes(cohort);
    const isEnrolled = cohort !== 'not-enrolled';
    return {
        cohort: cohort,
        isEnrolled: isEnrolled,
        isTreatment: isTreatment
    };
}

});

parcelRegister("dgipR", function(module, exports) {

$parcel$export(module.exports, "useProjectType", () => $c7374d2f02e81f13$export$6de29d851c914935);

var $7ZZxN = parcelRequire("7ZZxN");

var $cPEpP = parcelRequire("cPEpP");
function $c7374d2f02e81f13$export$6de29d851c914935() {
    // project type (software, service desk, etc) so we can target JSW projects
    // we do not look at whether the project is still loading
    // if data is undefined we will return undefined
    const { data: project } = (0, $cPEpP.useProject)();
    const projectType = (0, $7ZZxN.toProjectType)(project?.type);
    return {
        projectType: projectType
    };
}

});

parcelRegister("2pc1v", function(module, exports) {

$parcel$export(module.exports, "useTrialDetails", () => $d339818490c066a6$export$be2f13183561cb);

var $34FZy = parcelRequire("34FZy");


var $gd0Sp = parcelRequire("gd0Sp");
function $d339818490c066a6$export$be2f13183561cb() {
    const { productEntitlementDetails: productEntitlementDetails, appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const jswEdition = appEditions?.software;
    const entitlementDetails = productEntitlementDetails?.[0, $2edfd53057852e41$export$1346c9aa3cbb477d];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem;
    const trialEndTime = entitlementDetails?.trialEndTime;
    const trialDaysLeft = (0, $34FZy.getTrialDaysLeft)(trialEndTime);
    const isInTrial = !!trialDaysLeft && trialDaysLeft > 0;
    return {
        jswEdition: jswEdition,
        billingSourceSystem: billingSourceSystem,
        trialDaysLeft: trialDaysLeft,
        isInTrial: isInTrial,
        trialEndTime: trialEndTime
    };
}

});
parcelRegister("34FZy", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $060274e6e50e467d$export$954628993bf3188e);
$parcel$export(module.exports, "projectToApplicationKey", () => $060274e6e50e467d$export$1af4fd6f5c543149);

var $7ZZxN = parcelRequire("7ZZxN");

const $060274e6e50e467d$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $060274e6e50e467d$export$954628993bf3188e = (trialEndTime)=>trialEndTime && Math.ceil(($060274e6e50e467d$export$9dbbf537dffaafc7(trialEndTime) - Date.now()) / 86400000);
const $060274e6e50e467d$export$271517afaa0c15eb = (trialEndTime)=>{
    const trialDaysLeft = $060274e6e50e467d$export$954628993bf3188e(trialEndTime);
    // Technically we do not know whether user is in grace period or not, but if user is able to access the Jira with no payment details
    // and is trialEndTime is missing or over we assume that site is in grace period
    return !trialDaysLeft || trialDaysLeft < 0;
};
const $060274e6e50e467d$export$1af4fd6f5c543149 = (project)=>{
    switch(project){
        // With spork, we should update core projects as it they were Software projects
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        case 0, $7ZZxN.CORE_PROJECT:
            return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return 0, $2edfd53057852e41$export$202f50ee62667e32;
        default:
            throw new Error(`Unsupported project: ${project}`);
    }
};

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';




parcelRegister("fi8kw", function(module, exports) {

$parcel$export(module.exports, "useCanShowExperiment", () => $9d6362b11c145b49$export$acc3825c421a3bd7);

var $eUqFw = parcelRequire("eUqFw");

var $6uNFR = parcelRequire("6uNFR");
function $9d6362b11c145b49$export$acc3825c421a3bd7({ skip: skip }) {
    const [canShowExperiment, setCanShowExperiment] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = (0, $6uNFR.useChoreographer)('jira-loss-aversion-standard', {
        start: ()=>setCanShowExperiment(true),
        stop: ()=>setCanShowExperiment(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!skip) startMessage();
        return ()=>{
            stopMessage();
        };
    }, [
        startMessage,
        stopMessage,
        skip
    ]);
    return {
        canShowExperiment: canShowExperiment
    };
}

});
parcelRegister("6uNFR", function(module, exports) {

$parcel$export(module.exports, "useChoreographer", () => $dbff780bfca374d0$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "useChoreographedRender", () => $dbff780bfca374d0$export$2cfd68294be82811);
$parcel$export(module.exports, "ChoreographedStatusContext", () => $dbff780bfca374d0$export$3ff96dbefca6b00d);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $dbff780bfca374d0$export$2eb1efa814fe4a);

var $eUqFw = parcelRequire("eUqFw");

var $5xY1g = parcelRequire("5xY1g");
var $67SDP = parcelRequire("67SDP");

var $6rW04 = parcelRequire("6rW04");

var $38OPi = parcelRequire("38OPi");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $dbff780bfca374d0$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment')) ?? 'prod';
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const { plugin: $dbff780bfca374d0$export$27fff9a48cfe124b, useChoreographer: $dbff780bfca374d0$export$9f0e2488ffd90f11 } = (0, $5xY1g.choreographerFactory)((0, $67SDP.ProductIds).JIRA, $dbff780bfca374d0$var$environment);
const $dbff780bfca374d0$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $dbff780bfca374d0$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eUqFw.useEffect)(()=>{
        const startMessageAsync = async ()=>{
            const disposition = await startMessage();
            onMessageDisposition?.(disposition);
        };
        startMessageAsync();
        return ()=>{
            stopMessage();
        };
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage
    ]);
    return shouldRender;
};
const $dbff780bfca374d0$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $dbff780bfca374d0$export$2eb1efa814fe4a = ()=>(0, $eUqFw.useContext)($dbff780bfca374d0$export$3ff96dbefca6b00d);

});


parcelRegister("dGcKA", function(module, exports) {

$parcel$export(module.exports, "useFireExposureEvents", () => $ca9844ea5f4416e7$export$5659c1a3e6829401);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8tM2T = parcelRequire("8tM2T");

var $jMP2a = parcelRequire("jMP2a");

var $e84zd = parcelRequire("e84zd");
const $ca9844ea5f4416e7$export$5659c1a3e6829401 = ({ skip: skip, experimentName: experimentName, extraAnalytics: extraAnalytics })=>{
    const { cohort: cohort } = (0, $e84zd.useExperimentEnrollment)({
        experimentName: experimentName,
        skip: skip
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireExposureEvents = (0, $eUqFw.useCallback)(()=>{
        if (skip) return;
        (0, $8tM2T.default).manuallyLogExperimentExposure(experimentName);
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jlaFeature exposed', {
            experimentName: experimentName,
            cohort: cohort,
            ...extraAnalytics
        });
    }, [
        createAnalyticsEvent,
        cohort,
        skip,
        extraAnalytics,
        experimentName
    ]);
    return {
        fireExposureEvents: fireExposureEvents
    };
};

});

parcelRegister("haZiZ", function(module, exports) {

$parcel$export(module.exports, "setHasSeenModal", () => $f573801e632e52a7$export$43ffcd9228973911);


var $8bpps = parcelRequire("8bpps");
const $f573801e632e52a7$export$43ffcd9228973911 = (expermientName, isUrgent)=>{
    if (expermientName === (0, $d08b9e75af3069cb$export$998e8261e98c7d7d)) isUrgent ? (0, $8bpps.setHasSeenUrgentModalAA)() : (0, $8bpps.setHasSeenFirstModalAA)();
    else isUrgent ? (0, $8bpps.setHasSeenUrgentModalAB)() : (0, $8bpps.setHasSeenFirstModalAB)();
};

});


parcelRegister("jQeWf", function(module, exports) {

$parcel$export(module.exports, "JiraLossAversionModal", () => $8d54b6eaecf96b68$export$bf5226ec0d5ecf12);

var $2Ay3e = parcelRequire("2Ay3e");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $dWLk9 = parcelRequire("dWLk9");

var $7m4L0 = parcelRequire("7m4L0");

var $gB2c5 = parcelRequire("gB2c5");

var $ltinT = parcelRequire("ltinT");
const $8d54b6eaecf96b68$export$bf5226ec0d5ecf12 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jiraLossAversionModal",
        packageName: "jiraLossAversion",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "loss-aversion.ui.loss-aversion-modal.jira-loss-aversion-modal-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8d54b6eaecf96b68$export$a562bad7894ec750, null)));
const $8d54b6eaecf96b68$var$GB_IN_BYTES = 1000000000;
const $8d54b6eaecf96b68$var$bytesToGB = (bytes)=>bytes / $8d54b6eaecf96b68$var$GB_IN_BYTES;
const $8d54b6eaecf96b68$export$a562bad7894ec750 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const data = (0, $iWLL0.useLazyLoadQuery)((0, $2Ay3e.default), {
        cloudId: cloudId
    });
    const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
    const entitlement = entitlementInfo?.entitlement;
    const configurePayment = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePayment;
    // This might come back as null from graphql but we want to default to undefined to make the types easier to work with
    const upgradeUrl = configurePayment?.experienceUrl || undefined;
    const userCanPay = !!configurePayment?.isAvailableToUser;
    const userCount = entitlementInfo?.__typename === 'CommerceEntitlementInfoCcp' ? entitlementInfo.entitlement?.subscription?.chargeDetails?.chargeQuantities?.[0]?.quantity || 1 : 1;
    if (userCount > 10) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltinT.UserLimitModal), {
        userCanPay: userCanPay,
        userCount: userCount
    });
    const attachmentStorageUsed = data?.jira?.attachmentStorageUsed || 0;
    const storageUsedInGB = $8d54b6eaecf96b68$var$bytesToGB(attachmentStorageUsed);
    if (attachmentStorageUsed > 2 * $8d54b6eaecf96b68$var$GB_IN_BYTES) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gB2c5.StorageModal), {
        userCanPay: userCanPay,
        upgradeUrl: upgradeUrl,
        storageUsedInGB: storageUsedInGB
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7m4L0.SplitPanelModal), {
        userCanPay: userCanPay,
        upgradeUrl: upgradeUrl
    });
};

});
parcelRegister("2Ay3e", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eb3ec652487b317$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cfdbd31aa2cf8fd7c67ea83fe44ffca8>>
 * @relayHash 6b9972d60c0c4209b04f34cb36c808d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6e5750c9c8d0d168aeb3e66e92f190237d0338693b3e21384f12de1260145e93
const $4eb3ec652487b317$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "applicationKey",
                        "value": "JIRA_SOFTWARE"
                    },
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ScalarField",
                "name": "attachmentStorageUsed"
            }
        ]
    }, v2 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "jira-software.ondemand"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "concreteType": "CcpChargeDetails",
        "kind": "LinkedField",
        "name": "chargeDetails",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpChargeQuantity",
                "kind": "LinkedField",
                "name": "chargeQuantities",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "quantity"
                    }
                ]
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "lossAversionModalQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePayment",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CcpSubscription",
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "lossAversionModalQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePayment",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v9 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CcpSubscription",
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6e5750c9c8d0d168aeb3e66e92f190237d0338693b3e21384f12de1260145e93",
            "metadata": {},
            "name": "lossAversionModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4eb3ec652487b317$var$node.hash = "1dc16bbf63c599e26ef1599be02b3255";
var $4eb3ec652487b317$export$2e2bcd8739ae039 = $4eb3ec652487b317$var$node;

});

parcelRegister("7m4L0", function(module, exports) {

$parcel$export(module.exports, "SplitPanelModal", () => $568fbf7a3359a1de$export$c18002dc7c50901b);

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $6zOB7 = parcelRequire("6zOB7");
var $fI650 = parcelRequire("fI650");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $LnhOi = parcelRequire("LnhOi");
var $8pww8 = parcelRequire("8pww8");
var $cni0k = parcelRequire("cni0k");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $2y8KF = parcelRequire("2y8KF");


var $9Z2je = parcelRequire("9Z2je");
var $2pc1v = parcelRequire("2pc1v");

var $bh1t0 = parcelRequire("bh1t0");

var $3sHPb = parcelRequire("3sHPb");

var $dE59V = parcelRequire("dE59V");

var $fNZ7R = parcelRequire("fNZ7R");

var $7sEo4 = parcelRequire("7sEo4");

var $9J1bV = parcelRequire("9J1bV");

var $cYqpI = parcelRequire("cYqpI");
const $568fbf7a3359a1de$export$c18002dc7c50901b = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "splitPanelModal",
        packageName: "jiraLossAversion",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($568fbf7a3359a1de$export$ee50c7bc3828b59b, {
        userCanPay: userCanPay,
        upgradeUrl: upgradeUrl
    }));
const $568fbf7a3359a1de$export$ee50c7bc3828b59b = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [showModal, setShowModal] = (0, $eUqFw.useState)(true);
    const { isUrgent: isUrgent } = (0, $9Z2je.useExperimentEligibility)((0, $d08b9e75af3069cb$export$855e843fe464d553));
    const { trialDaysLeft: trialDaysLeft } = (0, $2pc1v.useTrialDetails)();
    const addPaymentUrl = upgradeUrl || `https://admin.atlassian.com/billing/${cloudId}/payment-methods`;
    const origin = new (0, $jkH4Q.default)({
        product: 'jira'
    });
    const addPaymentDetailsUrl = origin.addToUrl(addPaymentUrl);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        (0, $2y8KF.fireButtonAnalytics)(createAnalyticsEvent, 'jlaCloseButton', {
            trialDaysLeft: trialDaysLeft,
            userCanPay: userCanPay,
            modal: 'jlaSplitPanel'
        });
        setShowModal(false);
    }, [
        createAnalyticsEvent,
        trialDaysLeft,
        userCanPay
    ]);
    const onAddPaymentDetails = (0, $eUqFw.useCallback)(()=>{
        (0, $2y8KF.fireButtonAnalytics)(createAnalyticsEvent, 'jlaAddPaymentButton', {
            trialDaysLeft: trialDaysLeft,
            userCanPay: userCanPay,
            modal: 'jlaSplitPanel'
        });
        setShowModal(false);
    }, [
        createAnalyticsEvent,
        trialDaysLeft,
        userCanPay
    ]);
    const getSubTitleText = (0, $eUqFw.useCallback)(()=>{
        if (isUrgent) return userCanPay ? formatMessage((0, $cYqpI.default).jswStandardSubTitleUrgent) : formatMessage((0, $cYqpI.default).jswStandardSubTitleUrgentNoPay);
        return userCanPay ? formatMessage((0, $cYqpI.default).jswStandardSubTitle) : formatMessage((0, $cYqpI.default).jswStandardSubTitleNoPay);
    }, [
        formatMessage,
        isUrgent,
        userCanPay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "jiraLossAversionSplit"
    }, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cni0k.Modal), {
        height: 536,
        title: formatMessage((0, $cYqpI.default).jswStandardTitle, {
            trialDaysLeft: trialDaysLeft
        }),
        subtitle: getSubTitleText(),
        onClose: onClose,
        testId: "loss-aversion.ui.loss-aversion-modal.split-panel",
        actions: userCanPay && addPaymentDetailsUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            onClick: onClose,
            appearance: "subtle"
        }, formatMessage((0, $cYqpI.default).jswStandardSecondaryCtaText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
            onClick: onAddPaymentDetails,
            appearance: "primary",
            href: addPaymentDetailsUrl,
            target: "_blank"
        }, formatMessage((0, $cYqpI.default).jswStandardPrimaryCtaText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            onClick: onClose,
            appearance: "subtle"
        }, formatMessage((0, $cYqpI.default).jswStandardPrimaryCtaTextNoPay)),
        right: userCanPay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $568fbf7a3359a1de$var$carouselStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LnhOi.Carousel), {
            height: 325
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pww8.CarouselSlide), {
            title: formatMessage((0, $cYqpI.default).jswStandardCarouslSlideUserLimit)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($bh1t0))),
            alt: "add people"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pww8.CarouselSlide), {
            title: formatMessage((0, $cYqpI.default).jswStandardCarouslSlideAuditLog)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3sHPb))),
            alt: "audit log"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pww8.CarouselSlide), {
            title: formatMessage((0, $cYqpI.default).jswStandardCarouslSlideUserAutomation)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dE59V))),
            alt: "automation"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pww8.CarouselSlide), {
            title: formatMessage((0, $cYqpI.default).jswStandardCarouslSlideUserPermissions)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($7sEo4))),
            alt: "user permission"
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $568fbf7a3359a1de$var$carouselStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LnhOi.Carousel), {
            height: 325
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pww8.CarouselSlide), {
            title: formatMessage((0, $cYqpI.default).jswStandardCarouslSlideUserLimit)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($bh1t0))),
            alt: "add people"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pww8.CarouselSlide), {
            title: formatMessage((0, $cYqpI.default).jswStandardCarouslSlideStorageLimit)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fNZ7R))),
            alt: "audit log"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pww8.CarouselSlide), {
            title: formatMessage((0, $cYqpI.default).jswStandardCarouslSlideUserAutomation)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dE59V))),
            alt: "automation"
        }))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9J1bV.BenefitsListSection), {
        canPay: userCanPay
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            experiment: (0, $d08b9e75af3069cb$export$855e843fe464d553),
            trialDaysLeft: trialDaysLeft,
            userCanPay: userCanPay
        }
    }));
};
const $568fbf7a3359a1de$var$carouselStyles = (0, $1ZAYh.xcss)({
    margin: 'auto'
});

});
parcelRegister("LnhOi", function(module, exports) {

$parcel$export(module.exports, "Carousel", () => $0dde2252d03792b9$export$144901db2ea8e967);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $lSV8Z = parcelRequire("lSV8Z");
var $5LHuc = parcelRequire("5LHuc");
var $2EVgw = parcelRequire("2EVgw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $gnlQO = parcelRequire("gnlQO");
const $0dde2252d03792b9$var$containerStyles = (0, $1ZAYh.xcss)({
    overflowX: 'hidden',
    width: '100%',
    paddingBlock: 'space.500',
    paddingInline: 'space.400'
});
const $0dde2252d03792b9$export$144901db2ea8e967 = ({ children: children, onSlideChange: onSlideChange, height: height = 405 })=>{
    const [index, setIndex] = (0, $eUqFw.useState)(0);
    const slides = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children);
    const slide = slides[index];
    const count = slides.length;
    const handleOnPrevious = (0, $eUqFw.useCallback)(()=>{
        const prevIndex = index - 1 < 0 ? count - 1 : index - 1;
        setIndex(prevIndex);
        onSlideChange?.({
            index: prevIndex,
            previousIndex: index
        });
    }, [
        index,
        count,
        onSlideChange
    ]);
    const handleOnNext = (0, $eUqFw.useCallback)(()=>{
        const nextIndex = index + 1 < count ? index + 1 : 0;
        setIndex(nextIndex);
        onSlideChange?.({
            index: nextIndex,
            previousIndex: index
        });
    }, [
        index,
        count,
        onSlideChange
    ]);
    const handleOnSelectIndex = (0, $eUqFw.useCallback)(({ index: nextIndex })=>{
        setIndex(nextIndex);
        onSlideChange?.({
            index: nextIndex,
            previousIndex: index
        });
    }, [
        onSlideChange,
        index
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        xcss: $0dde2252d03792b9$var$containerStyles,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
        exitThenEnter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        key: index
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2EVgw.default), {
        enterFrom: "right",
        exitTo: "left",
        fade: "inout",
        duration: (0, $5LHuc.mediumDurationMs)
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                height: height
            },
            ...props,
            id: `slide${index}`
        }, slide)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXKde))),
        label: "Previous",
        onClick: handleOnPrevious
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gnlQO.default), {
        selectedIndex: index,
        values: slides.map((_, idx)=>idx),
        onSelect: handleOnSelectIndex,
        appearance: "primary",
        ariaControls: "slide"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))),
        label: "Next",
        onClick: handleOnNext
    })));
};

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db781ab5297a2cc1540c99d75921a718>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});

parcelRegister("gnlQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $24f510a9e7e3fedf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $5gfRs = parcelRequire("5gfRs");

var $2EgO8 = parcelRequire("2EgO8");
const $24f510a9e7e3fedf$var$packageName = "platform-pkg";
const $24f510a9e7e3fedf$var$packageVersion = "0.0.0-use.local";
/**
 * __ProgressDots__
 *
 * A progress indicator shows the user where they are along the steps of a journey.
 */ const $24f510a9e7e3fedf$var$ProgressDots = ({ appearance: appearance = 'default', ariaControls: ariaControls = 'panel', ariaLabel: ariaLabel = 'tab', size: size = 'default', // NOTE: `spacing` is a reserved HTML attribute and will be added to the
// element, replaced with `gutter`.
spacing: gutter = 'comfortable', selectedIndex: selectedIndex, testId: testId, values: values, onSelect: onSelect })=>{
    const tablistRef = (0, $eUqFw.useRef)(null);
    const onSelectWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onSelect || (0, $5Q9wj.default),
        action: 'selected',
        componentName: 'progressIndicator',
        packageName: $24f510a9e7e3fedf$var$packageName,
        packageVersion: $24f510a9e7e3fedf$var$packageVersion
    });
    const [inlineGapValue, rawGapValue] = (0, $5gfRs.progressIndicatorGapMap)[gutter][size];
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const indicators = Array.from(tablistRef.current.children);
        // bail if the target isn't an indicator
        if (!indicators.includes(event.target)) return;
        // bail if not valid arrow key
        const isLeft = event.key === 'ArrowLeft';
        const isRight = event.key === 'ArrowRight';
        if (!isLeft && !isRight) return;
        // bail if at either end of the values
        const isAlpha = isLeft && selectedIndex === 0;
        const isOmega = isRight && selectedIndex === values.length - 1;
        if (isAlpha || isOmega) return;
        const index = isLeft ? selectedIndex - 1 : selectedIndex + 1;
        // call the consumer's select method and focus the applicable indicator
        if (onSelect) onSelectWithAnalytics({
            event: event,
            index: index
        });
        if (typeof indicators[index].focus === 'function') indicators[index].focus();
    }, [
        onSelectWithAnalytics,
        selectedIndex,
        values,
        onSelect
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!onSelect) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(document, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: false
            }
        });
    }, [
        onSelect,
        handleKeyDown
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $5gfRs.varDotsSize)]: `${(0, $5gfRs.sizes)[size]}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $5gfRs.varDotsMargin)]: rawGapValue
        },
        role: onSelect && 'tablist'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        testId: testId,
        ref: (r)=>{
            tablistRef.current = r;
        },
        alignInline: "center",
        space: inlineGapValue
    }, values.map((_, index)=>{
        const isSelected = selectedIndex === index;
        const tabId = `${ariaLabel}${index}`;
        const panelId = `${ariaControls}${index}`;
        const indicatorTestId = testId && `${testId}-ind-${index}`;
        return onSelect ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $2EgO8.ButtonIndicator), {
            key: index,
            testId: indicatorTestId,
            appearance: appearance,
            isSelected: isSelected,
            tabId: tabId,
            panelId: panelId,
            onClick: (event)=>onSelectWithAnalytics({
                    event: event,
                    index: index
                })
        }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $2EgO8.PresentationalIndicator), {
            key: index,
            testId: indicatorTestId,
            appearance: appearance,
            isSelected: isSelected
        });
    })));
};
var $24f510a9e7e3fedf$export$2e2bcd8739ae039 = $24f510a9e7e3fedf$var$ProgressDots;

});
parcelRegister("5gfRs", function(module, exports) {

$parcel$export(module.exports, "progressIndicatorGapMap", () => $509959c700b79938$export$c7b941bbc227445b);
$parcel$export(module.exports, "sizes", () => $509959c700b79938$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "varDotsSize", () => $509959c700b79938$export$83c4f86b79228049);
$parcel$export(module.exports, "varDotsMargin", () => $509959c700b79938$export$b391856a24c21681);
const $509959c700b79938$export$c7b941bbc227445b = {
    comfortable: {
        default: [
            'space.100',
            "var(--ds-space-100, 8px)"
        ],
        large: [
            'space.150',
            "var(--ds-space-150, 12px)"
        ]
    },
    cozy: {
        default: [
            'space.075',
            "var(--ds-space-075, 6px)"
        ],
        large: [
            'space.100',
            "var(--ds-space-100, 8px)"
        ]
    },
    compact: {
        default: [
            'space.050',
            "var(--ds-space-050, 4px)"
        ],
        large: [
            'space.075',
            "var(--ds-space-075, 6px)"
        ]
    }
};
const $509959c700b79938$export$c647cb0ee6e282fe = {
    default: 8,
    large: 12
};
const $509959c700b79938$export$83c4f86b79228049 = '--ds-dots-size';
const $509959c700b79938$export$b391856a24c21681 = '--ds-dots-margin';

});

parcelRegister("2EgO8", function(module, exports) {

$parcel$export(module.exports, "PresentationalIndicator", () => $9952f418e4b1634d$export$ec3c81af58a0c4e7);
$parcel$export(module.exports, "ButtonIndicator", () => $9952f418e4b1634d$export$3716cb524d6018c1);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");

var $5gfRs = parcelRequire("5gfRs");
// TODO Token usages are not consistent for dots https://product-fabric.atlassian.net/browse/DSP-3180
const $9952f418e4b1634d$var$colorMap = {
    default: (0, $1ZAYh.xcss)({
        backgroundColor: 'color.background.neutral'
    }),
    help: (0, $1ZAYh.xcss)({
        backgroundColor: 'color.background.neutral'
    }),
    inverted: (0, $1ZAYh.xcss)({
        // @ts-expect-error
        backgroundColor: "var(--ds-icon-subtle, #626F86)"
    }),
    primary: (0, $1ZAYh.xcss)({
        backgroundColor: 'color.background.neutral'
    })
};
const $9952f418e4b1634d$var$selectedColorMap = {
    default: (0, $1ZAYh.xcss)({
        // @ts-expect-error
        backgroundColor: "var(--ds-icon, #44546F)"
    }),
    help: (0, $1ZAYh.xcss)({
        // @ts-expect-error
        backgroundColor: "var(--ds-icon-discovery, #8270DB)"
    }),
    inverted: (0, $1ZAYh.xcss)({
        // @ts-expect-error
        backgroundColor: "var(--ds-icon-inverse, #FFFFFF)"
    }),
    primary: (0, $1ZAYh.xcss)({
        // @ts-expect-error
        backgroundColor: "var(--ds-icon-brand, #0C66E4)"
    })
};
const $9952f418e4b1634d$var$commonStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `var(${(0, $5gfRs.varDotsSize)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `var(${(0, $5gfRs.varDotsSize)})`,
    position: 'relative',
    borderRadius: 'border.radius.circle',
    '::before': {
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(var(${(0, $5gfRs.varDotsSize)}) + var(${(0, $5gfRs.varDotsMargin)}))`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(var(${(0, $5gfRs.varDotsSize)}) + var(${(0, $5gfRs.varDotsMargin)}))`,
        position: 'absolute',
        content: '""',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(-1 * var(${(0, $5gfRs.varDotsMargin)}) / 2)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `calc(-1 * var(${(0, $5gfRs.varDotsMargin)}) / 2)`
    }
});
const $9952f418e4b1634d$var$buttonStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    border: 0,
    cursor: 'pointer',
    outline: 0
});
const $9952f418e4b1634d$export$ec3c81af58a0c4e7 = ({ appearance: appearance, isSelected: isSelected, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        xcss: [
            $9952f418e4b1634d$var$commonStyles,
            appearance === 'default' && !isSelected && $9952f418e4b1634d$var$colorMap['default'],
            appearance === 'help' && !isSelected && $9952f418e4b1634d$var$colorMap['help'],
            appearance === 'inverted' && !isSelected && $9952f418e4b1634d$var$colorMap['inverted'],
            appearance === 'primary' && !isSelected && $9952f418e4b1634d$var$colorMap['primary'],
            appearance === 'default' && isSelected && $9952f418e4b1634d$var$selectedColorMap['default'],
            appearance === 'help' && isSelected && $9952f418e4b1634d$var$selectedColorMap['help'],
            appearance === 'inverted' && isSelected && $9952f418e4b1634d$var$selectedColorMap['inverted'],
            appearance === 'primary' && isSelected && $9952f418e4b1634d$var$selectedColorMap['primary']
        ]
    });
const $9952f418e4b1634d$export$3716cb524d6018c1 = ({ appearance: appearance, panelId: panelId, tabId: tabId, isSelected: isSelected, onClick: onClick, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        role: "tab",
        xcss: [
            $9952f418e4b1634d$var$commonStyles,
            $9952f418e4b1634d$var$buttonStyles,
            appearance === 'default' && !isSelected && $9952f418e4b1634d$var$colorMap['default'],
            appearance === 'help' && !isSelected && $9952f418e4b1634d$var$colorMap['help'],
            appearance === 'inverted' && !isSelected && $9952f418e4b1634d$var$colorMap['inverted'],
            appearance === 'primary' && !isSelected && $9952f418e4b1634d$var$colorMap['primary'],
            appearance === 'default' && isSelected && $9952f418e4b1634d$var$selectedColorMap['default'],
            appearance === 'help' && isSelected && $9952f418e4b1634d$var$selectedColorMap['help'],
            appearance === 'inverted' && isSelected && $9952f418e4b1634d$var$selectedColorMap['inverted'],
            appearance === 'primary' && isSelected && $9952f418e4b1634d$var$selectedColorMap['primary']
        ],
        "aria-controls": panelId,
        "aria-selected": isSelected,
        id: tabId,
        onClick: onClick,
        tabIndex: isSelected ? -1 : undefined,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, tabId));
};

});



parcelRegister("8pww8", function(module, exports) {

$parcel$export(module.exports, "CarouselSlide", () => $29fb4c79704594d5$export$cabb5ccfbd60cbd4);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $29fb4c79704594d5$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '100%'
});
const $29fb4c79704594d5$var$headingStyles = (0, $1ZAYh.xcss)({
    textAlign: 'center'
});
const $29fb4c79704594d5$var$childrenStyles = (0, $1ZAYh.xcss)({
    overflowY: 'auto',
    width: '100%',
    flexGrow: 1,
    height: '100%'
});
const $29fb4c79704594d5$var$titleStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-regular, 400)",
    textAlign: 'center',
    // Remove the automatic margin applied to p tags.
    marginTop: 'space.0'
});
const $29fb4c79704594d5$export$cabb5ccfbd60cbd4 = ({ heading: heading, children: children, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        alignInline: "center",
        xcss: $29fb4c79704594d5$var$containerStyles,
        testId: "growth-pattern-library-modal-carousel-slide"
    }, heading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $29fb4c79704594d5$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "span",
        size: "small"
    }, heading)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $29fb4c79704594d5$var$childrenStyles
    }, children), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: $29fb4c79704594d5$var$titleStyles
    }, title) : null);

});

parcelRegister("cni0k", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $7b50e0b4ded77a31$export$2b77a92f1a5ad772);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Ywu9 = parcelRequire("4Ywu9");

var $2HfCk = parcelRequire("2HfCk");

var $bk4nb = parcelRequire("bk4nb");

var $hjQtW = parcelRequire("hjQtW");
const $7b50e0b4ded77a31$var$container = (0, $1ZAYh.xcss)({
    overflowY: 'auto',
    height: '100%',
    [(0, $4Ywu9.media).above.sm]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
    }
});
const $7b50e0b4ded77a31$var$stack = (0, $1ZAYh.xcss)({
    height: '100%',
    padding: 'space.600',
    overflowY: 'auto'
});
const $7b50e0b4ded77a31$var$rightContainer = (0, $1ZAYh.xcss)({
    display: 'none',
    [(0, $4Ywu9.media).above.sm]: {
        backgroundColor: 'color.background.accent.gray.subtlest',
        display: 'flex',
        width: '100%',
        overflowY: 'auto'
    }
});
const $7b50e0b4ded77a31$export$2b77a92f1a5ad772 = ({ logo: logo, title: title, subtitle: subtitle, children: children, actions: actions, right: right, ...modalProps })=>{
    const includesRight = right !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: includesRight ? 'x-large' : undefined,
        autoFocus: false,
        ...modalProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: includesRight && $7b50e0b4ded77a31$var$container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.400",
        xcss: $7b50e0b4ded77a31$var$stack
    }, logo, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hjQtW.ModalTitle), null, title), subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle",
        size: "medium"
    }, subtitle) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2HfCk.ModalBody), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bk4nb.ModalFooter), null, actions)), includesRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $7b50e0b4ded77a31$var$rightContainer
    }, right)));
};

});
parcelRegister("2HfCk", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $83bd5d916908ac90$export$cb540d8b0ef7906c);

var $eUqFw = parcelRequire("eUqFw");

var $8MHxr = parcelRequire("8MHxr");

var $cMtFc = parcelRequire("cMtFc");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $83bd5d916908ac90$var$container = (0, $1ZAYh.xcss)({
    flex: '1 1 auto',
    overflowY: 'auto'
});
const $83bd5d916908ac90$export$cb540d8b0ef7906c = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MHxr.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.300",
        xcss: $83bd5d916908ac90$var$container,
        testId: testId
    }, children));
};

});

parcelRegister("bk4nb", function(module, exports) {

$parcel$export(module.exports, "ModalFooter", () => $dc1b82263d922623$export$519437715052e656);

var $eUqFw = parcelRequire("eUqFw");

var $cMtFc = parcelRequire("cMtFc");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");
const $dc1b82263d922623$var$wrapStyles = (0, $1ZAYh.xcss)({
    flexWrap: 'wrap-reverse'
});
const $dc1b82263d922623$export$519437715052e656 = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignInline: "end",
        testId: testId,
        space: "space.150",
        xcss: $dc1b82263d922623$var$wrapStyles
    }, children);
};

});

parcelRegister("hjQtW", function(module, exports) {

$parcel$export(module.exports, "ModalTitle", () => $c37d1910e4ade1bf$export$b26fae16ba5468aa);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $cMtFc = parcelRequire("cMtFc");
const $c37d1910e4ade1bf$export$b26fae16ba5468aa = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        testId: testId,
        size: "large",
        id: titleId
    }, children);
};

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("2y8KF", function(module, exports) {

$parcel$export(module.exports, "fireButtonAnalytics", () => $cb4329c28b2f24d0$export$ac665b9f9662b94a);

var $jMP2a = parcelRequire("jMP2a");

const $cb4329c28b2f24d0$export$ac665b9f9662b94a = (createAnalyticsEvent, actionSubjectId, attributes)=>{
    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked',
        source: 'jira'
    }), actionSubjectId, {
        ...attributes
    });
};
const $cb4329c28b2f24d0$export$a27c21aa3ed8f0f1 = (createAnalyticsEvent, reason)=>{
    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
        source: 'jira'
    }), 'experiment error', {
        reason: reason,
        experimentKey: (0, $d08b9e75af3069cb$export$855e843fe464d553)
    });
};
const $cb4329c28b2f24d0$export$d5afa3e4b289a23 = (createAnalyticsEvent, actionSubjectId, attributes)=>{
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
        source: 'jira'
    }), actionSubjectId, {
        experimentKey: (0, $d08b9e75af3069cb$export$855e843fe464d553),
        ...attributes
    });
};

});

parcelRegister("bh1t0", function(module, exports) {
module.exports = new URL("addPeople.cb761064.svg", import.meta.url).toString();

});

parcelRegister("3sHPb", function(module, exports) {
module.exports = new URL("auditLog.9720e9be.svg", import.meta.url).toString();

});

parcelRegister("dE59V", function(module, exports) {
module.exports = new URL("automation.ca873ee6.svg", import.meta.url).toString();

});

parcelRegister("fNZ7R", function(module, exports) {
module.exports = new URL("storage.1fbb6bc1.svg", import.meta.url).toString();

});

parcelRegister("7sEo4", function(module, exports) {
module.exports = new URL("userPermissions.7b801eb7.svg", import.meta.url).toString();

});

parcelRegister("9J1bV", function(module, exports) {

$parcel$export(module.exports, "BenefitsListSection", () => $f16a1b4b63d66e2f$export$50891c0e4b7fa982);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $X5vzS = parcelRequire("X5vzS");

var $awxD3 = parcelRequire("awxD3");
function $f16a1b4b63d66e2f$export$50891c0e4b7fa982({ canPay: canPay }) {
    const benefitsListContent = (0, $eUqFw.useMemo)(()=>(0, $awxD3.getBenefitsListContent)(canPay), [
        canPay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f16a1b4b63d66e2f$var$BenefitsListSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f16a1b4b63d66e2f$var$BenefitsBodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $X5vzS.BenefitsList), {
        benefits: benefitsListContent || []
    })));
}
const $f16a1b4b63d66e2f$var$BenefitsListSectionStyles = (0, $1ZAYh.xcss)({
    boxSizing: 'border-box',
    minHeight: '236px'
});
const $f16a1b4b63d66e2f$var$BenefitsBodyStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.250'
});

});
parcelRegister("X5vzS", function(module, exports) {

$parcel$export(module.exports, "BenefitsList", () => $2cf3595fce36be57$export$ccb2870a847830f2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");
function $2cf3595fce36be57$export$ccb2870a847830f2({ benefits: benefits }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", {
        className: (0, $7JEyt.default)([
            "_qtt8glyw _19bvidpf"
        ])
    }, benefits.map((benefit, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: index,
            className: (0, $7JEyt.default)([
                "_n3tdv47k _19pkidpf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            xcss: $2cf3595fce36be57$var$ListItemStyles,
            key: benefit.description.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                $2cf3595fce36be57$var$IconStyles
            ]
        }, benefit.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            weight: "bold"
        }, formatMessage(benefit.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage(benefit.description)))))))));
}
const $2cf3595fce36be57$var$IconStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.selected',
    borderRadius: 'border.radius.circle',
    display: 'flex',
    width: '24px',
    height: '24px',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: '0'
});
const $2cf3595fce36be57$var$BenefitsListStyles = null;
const $2cf3595fce36be57$var$BenefitsListItemStyles = null;
const $2cf3595fce36be57$var$ListItemStyles = (0, $1ZAYh.xcss)({
    alignItems: 'center',
    gap: 'space.200'
});

});

parcelRegister("awxD3", function(module, exports) {

$parcel$export(module.exports, "getBenefitsListContent", () => $f003146e471ef1b6$export$315c3830bbc61e3c);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $5oiKm = parcelRequire("5oiKm");

var $29Y8f = parcelRequire("29Y8f");

var $iisnK = parcelRequire("iisnK");

var $6Klpz = parcelRequire("6Klpz");

var $kdJSi = parcelRequire("kdJSi");

var $k4zXJ = parcelRequire("k4zXJ");
const $f003146e471ef1b6$var$AutomationIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        size: "medium",
        glyph: (0, $kdJSi.AutomationGlyph),
        label: label,
        secondaryColor: "none"
    });
const $f003146e471ef1b6$var$jswEditionBenefits = new Map(Object.entries({
    canPay: [
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iisnK))), {
                size: "medium",
                label: "People group icon"
            }),
            title: (0, $k4zXJ.default).jswStandardUnlimitedUsersTitle,
            description: (0, $k4zXJ.default).jswStandardUnlimitedUsersSubText
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($29Y8f))), {
                size: "medium",
                label: "File icon"
            }),
            title: (0, $k4zXJ.default).jswStandardAuditLogTitle,
            description: (0, $k4zXJ.default).jswStandardAuditLogSubText
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f003146e471ef1b6$var$AutomationIcon, {
                label: "Automation icon"
            }),
            title: (0, $k4zXJ.default).jswStandardAutomationsTitle,
            description: (0, $k4zXJ.default).jswStandardAutomationsSubText
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Klpz))), {
                size: "medium",
                label: "Unlock filled icon"
            }),
            title: (0, $k4zXJ.default).jswStandardIssuePermissionsTitle,
            description: (0, $k4zXJ.default).jswStandardIssuePermissionsSubText
        }
    ],
    notPay: [
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iisnK))), {
                size: "medium",
                label: "People group icon"
            }),
            title: (0, $k4zXJ.default).jswStandardUnlimitedUsersTitle,
            description: (0, $k4zXJ.default).jswStandardUnlimitedUsersSubText
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5oiKm))), {
                size: "medium",
                label: "Export icon"
            }),
            title: (0, $k4zXJ.default).jswStandardStorageTitle,
            description: (0, $k4zXJ.default).jswStandardStorageSubText
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f003146e471ef1b6$var$AutomationIcon, {
                label: "Automation icon"
            }),
            title: (0, $k4zXJ.default).jswStandardAutomationsTitle,
            description: (0, $k4zXJ.default).jswStandardAutomationsSubText
        }
    ]
}));
const $f003146e471ef1b6$export$315c3830bbc61e3c = (canPay)=>canPay ? $f003146e471ef1b6$var$jswEditionBenefits.get('canPay') : $f003146e471ef1b6$var$jswEditionBenefits.get('notPay');

});
parcelRegister("5oiKm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0103517d4ae70c89$var$_react = $0103517d4ae70c89$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $0103517d4ae70c89$var$_upload = $0103517d4ae70c89$var$_interopRequireDefault((parcelRequire("3Mygk")));
function $0103517d4ae70c89$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0103517d4ae70c89$var$ExportIcon = (props)=>/*#__PURE__*/ $0103517d4ae70c89$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props, {
        newIcon: $0103517d4ae70c89$var$_upload.default
    }));
$0103517d4ae70c89$var$ExportIcon.displayName = 'ExportIcon';
var $0103517d4ae70c89$var$_default = module.exports.default = $0103517d4ae70c89$var$ExportIcon;

});
parcelRegister("3Mygk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76ccf606647435d6346c379dcf7dbb9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c106e989d1556d4$var$_react = $2c106e989d1556d4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2c106e989d1556d4$var$_UNSAFE_baseNew = $2c106e989d1556d4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $2c106e989d1556d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c106e989d1556d4$var$UploadIcon = (props)=>/*#__PURE__*/ $2c106e989d1556d4$var$_react.default.createElement($2c106e989d1556d4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1.75V11M4 5.75l4-4 4 4"/>`
    }, props));
$2c106e989d1556d4$var$UploadIcon.displayName = 'UploadIcon';
var $2c106e989d1556d4$var$_default = module.exports.default = $2c106e989d1556d4$var$UploadIcon;

});


parcelRegister("29Y8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $192b110733c90331$var$_react = $192b110733c90331$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $192b110733c90331$var$_file = $192b110733c90331$var$_interopRequireDefault((parcelRequire("dekbE")));
function $192b110733c90331$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $192b110733c90331$var$FileIcon = (props)=>/*#__PURE__*/ $192b110733c90331$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/><rect width="8" height="2" x="8" y="12" rx="1"/><rect width="4" height="2" x="8" y="15" rx="1"/></g></svg>`
    }, props, {
        newIcon: $192b110733c90331$var$_file.default
    }));
$192b110733c90331$var$FileIcon.displayName = 'FileIcon';
var $192b110733c90331$var$_default = module.exports.default = $192b110733c90331$var$FileIcon;

});
parcelRegister("dekbE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb51c4d43dbcfeceb899912fc33494f6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a1c3de0d8760d3b$var$_react = $9a1c3de0d8760d3b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9a1c3de0d8760d3b$var$_UNSAFE_baseNew = $9a1c3de0d8760d3b$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9a1c3de0d8760d3b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a1c3de0d8760d3b$var$FileIcon = (props)=>/*#__PURE__*/ $9a1c3de0d8760d3b$var$_react.default.createElement($9a1c3de0d8760d3b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 5.25V14c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25V2c0-.69.56-1.25 1.25-1.25h4.75m4.5 4.5h-4.5V.75m4.5 4.5c0-.32-.127-.627-.354-.854L9.604 1.104A1.2 1.2 0 0 0 8.75.75"/>`
    }, props));
$9a1c3de0d8760d3b$var$FileIcon.displayName = 'FileIcon';
var $9a1c3de0d8760d3b$var$_default = module.exports.default = $9a1c3de0d8760d3b$var$FileIcon;

});


parcelRegister("iisnK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d51fec82b4cf5254$var$_react = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d51fec82b4cf5254$var$_personAdd = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("kdBCz")));
function $d51fec82b4cf5254$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d51fec82b4cf5254$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d51fec82b4cf5254$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $d51fec82b4cf5254$var$_personAdd.default
    }));
$d51fec82b4cf5254$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d51fec82b4cf5254$var$_default = module.exports.default = $d51fec82b4cf5254$var$InviteTeamIcon;

});
parcelRegister("kdBCz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1db644828b4f838ff6385efd15aa7229>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb823455dae27cb1$var$_react = $eb823455dae27cb1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $eb823455dae27cb1$var$_UNSAFE_baseNew = $eb823455dae27cb1$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $eb823455dae27cb1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb823455dae27cb1$var$PersonAddIcon = (props)=>/*#__PURE__*/ $eb823455dae27cb1$var$_react.default.createElement($eb823455dae27cb1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15M13 8V5m0 3v3m0-3h3m-3 0h-3M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$eb823455dae27cb1$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $eb823455dae27cb1$var$_default = module.exports.default = $eb823455dae27cb1$var$PersonAddIcon;

});


parcelRegister("6Klpz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e97a5d2a536718f$var$_react = $4e97a5d2a536718f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4e97a5d2a536718f$var$_lockUnlocked = $4e97a5d2a536718f$var$_interopRequireDefault((parcelRequire("8Azp3")));
function $4e97a5d2a536718f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4e97a5d2a536718f$var$UnlockFilledIcon = (props)=>/*#__PURE__*/ $4e97a5d2a536718f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 11.009C5 9.899 5.897 9 7.006 9h9.988A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991zM12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/><path fill-rule="nonzero" d="M8 6.251v-.249A4.004 4.004 0 0 1 12 2a4 4 0 0 1 4 4.002V6.5h-2v-.498A2 2 0 0 0 12 4c-1.102 0-2 .898-2 2.002V11H8zm6 .249h2a1 1 0 0 1-2 0"/></g></svg>`
    }, props, {
        newIcon: $4e97a5d2a536718f$var$_lockUnlocked.default
    }));
$4e97a5d2a536718f$var$UnlockFilledIcon.displayName = 'UnlockFilledIcon';
var $4e97a5d2a536718f$var$_default = module.exports.default = $4e97a5d2a536718f$var$UnlockFilledIcon;

});
parcelRegister("8Azp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45dd2cdeb084f78f202948ae116275ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $640d25dbf3b34473$var$_react = $640d25dbf3b34473$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $640d25dbf3b34473$var$_UNSAFE_baseNew = $640d25dbf3b34473$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $640d25dbf3b34473$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $640d25dbf3b34473$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $640d25dbf3b34473$var$_react.default.createElement($640d25dbf3b34473$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.25 4a3.25 3.25 0 1 0-6.5 0v3.75m0 0H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25z"/>`
    }, props));
$640d25dbf3b34473$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $640d25dbf3b34473$var$_default = module.exports.default = $640d25dbf3b34473$var$LockUnlockedIcon;

});


parcelRegister("kdJSi", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $d609bfcc752dad25$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $d609bfcc752dad25$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("k4zXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1834e1f458401cc4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1834e1f458401cc4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jswStandardUnlimitedUsersTitle: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-unlimited-users-title",
        "defaultMessage": "Unlimited users"
    },
    jswStandardUnlimitedUsersSubText: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-unlimited-users-sub-text",
        "defaultMessage": "Get your entire team in one tool"
    },
    jswStandardAuditLogTitle: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-audit-log-title",
        "defaultMessage": "Audit log"
    },
    jswStandardAuditLogSubText: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-audit-log-sub-text",
        "defaultMessage": "Review and troubleshoot site changes"
    },
    jswStandardAutomationsTitle: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-automations-title",
        "defaultMessage": "1,700 automation runs"
    },
    jswStandardAutomationsSubText: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-automations-sub-text",
        "defaultMessage": "Save time by automating routine tasks"
    },
    jswStandardIssuePermissionsTitle: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-issue-permissions-title",
        "defaultMessage": "Issue permissions "
    },
    jswStandardIssuePermissionsSubText: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-issue-permissions-sub-text",
        "defaultMessage": "Decide who can view, comment, and create"
    },
    jswStandardStorageTitle: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-storage-title",
        "defaultMessage": "250 GB of storage"
    },
    jswStandardStorageSubText: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-storage-sub-text",
        "defaultMessage": "Upload files without running out of space"
    },
    jswStandardCarouslSlideUserLimit: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-user-limit",
        "defaultMessage": "Unlimited People"
    },
    jswStandardCarouslSlideAuditLog: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-audit-log",
        "defaultMessage": "Audit Log"
    },
    jswStandardCarouslSlideUserAutomation: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-user-automation",
        "defaultMessage": "Automation"
    },
    jswStandardCarouslSlideUserPermissions: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-user-permissions",
        "defaultMessage": "User permissions"
    },
    jswStandardCarouslSlideStorageLimit: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-storage-limit",
        "defaultMessage": "Storage limit"
    }
});

});



parcelRegister("cYqpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $787bc968543bc4f4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $787bc968543bc4f4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jswStandardCarouslSlideUserLimit: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-user-limit",
        "defaultMessage": "Unlimited users"
    },
    jswStandardCarouslSlideAuditLog: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-audit-log",
        "defaultMessage": "Audit Log"
    },
    jswStandardCarouslSlideUserAutomation: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-user-automation",
        "defaultMessage": "Automation"
    },
    jswStandardCarouslSlideUserPermissions: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-user-permissions",
        "defaultMessage": "User permissions"
    },
    jswStandardCarouslSlideStorageLimit: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-storage-limit",
        "defaultMessage": "Storage limit"
    },
    jswStandardTitle: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-title",
        "defaultMessage": "Your Standard trial ends in {trialDaysLeft, plural, one {# day} other {# days}}"
    },
    jswStandardSubTitle: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title",
        "defaultMessage": "There\u2019s still time to try advanced features. Don\u2019t lose access \u2014 add payment before your trial ends."
    },
    jswStandardSubTitleUrgent: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title-urgent",
        "defaultMessage": "Don\u2019t lose access to advanced features. Add payment before your trial ends."
    },
    jswStandardSubTitleNoPay: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title-no-pay",
        "defaultMessage": "There\u2019s still time to try advanced features. Don\u2019t lose access \u2014 ask your admin to purchase Jira Standard."
    },
    jswStandardSubTitleUrgentNoPay: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title-urgent-no-pay",
        "defaultMessage": "Don\u2019t lose access to advanced features. Ask your admin to purchase Jira Standard for your team."
    },
    jswStandardPrimaryCtaText: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-primary-cta-text",
        "defaultMessage": "Add payment"
    },
    jswStandardPrimaryCtaTextNoPay: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-primary-cta-text-no-pay",
        "defaultMessage": "Close"
    },
    jswStandardSecondaryCtaText: {
        "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-secondary-cta-text",
        "defaultMessage": "Maybe later"
    }
});

});


parcelRegister("gB2c5", function(module, exports) {

$parcel$export(module.exports, "StorageModal", () => $ba995786e4465c50$export$de0de9a0c528fc33);

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $6zOB7 = parcelRequire("6zOB7");
var $fI650 = parcelRequire("fI650");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cni0k = parcelRequire("cni0k");

var $fyE0l = parcelRequire("fyE0l");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $2y8KF = parcelRequire("2y8KF");


var $9Z2je = parcelRequire("9Z2je");
var $2pc1v = parcelRequire("2pc1v");

var $29rFz = parcelRequire("29rFz");
const $ba995786e4465c50$export$de0de9a0c528fc33 = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl, storageUsedInGB: storageUsedInGB })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "storageModal",
        packageName: "jiraLossAversion",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba995786e4465c50$export$a6bf7c84b3543a58, {
        userCanPay: userCanPay,
        upgradeUrl: upgradeUrl,
        storageUsedInGB: storageUsedInGB
    }));
const $ba995786e4465c50$export$a6bf7c84b3543a58 = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl, storageUsedInGB: storageUsedInGB })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5JgJ2.default)();
    const { isUrgent: isUrgent } = (0, $9Z2je.useExperimentEligibility)((0, $d08b9e75af3069cb$export$855e843fe464d553));
    const { trialEndTime: trialEndTime } = (0, $2pc1v.useTrialDetails)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const addPaymentUrl = upgradeUrl || `https://admin.atlassian.com/billing/${cloudId}/payment-methods`;
    const origin = new (0, $jkH4Q.default)({
        product: 'jira'
    });
    const addPaymentDetailsUrl = origin.addToUrl(addPaymentUrl);
    const [showModal, setShowModal] = (0, $eUqFw.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const trialEndDate = trialEndTime && formatDate(new Date(trialEndTime), {
        day: 'numeric',
        month: 'long'
    });
    const onClose = (0, $eUqFw.useCallback)(()=>{
        (0, $2y8KF.fireButtonAnalytics)(createAnalyticsEvent, 'jlaCloseButton', {
            userCanPay: userCanPay,
            upgradeUrl: upgradeUrl,
            storageUsedInGB: storageUsedInGB,
            trialEndTime: trialEndTime,
            modal: 'jlaStorage'
        });
        setShowModal(false);
    }, [
        createAnalyticsEvent,
        storageUsedInGB,
        trialEndTime,
        upgradeUrl,
        userCanPay
    ]);
    const onAddPaymentDetails = (0, $eUqFw.useCallback)(()=>{
        (0, $2y8KF.fireButtonAnalytics)(createAnalyticsEvent, 'jlaAddPaymentButton', {
            userCanPay: userCanPay,
            upgradeUrl: upgradeUrl,
            storageUsedInGB: storageUsedInGB,
            trialEndTime: trialEndTime,
            modal: 'jlaStorage'
        });
        setShowModal(false);
    }, [
        createAnalyticsEvent,
        storageUsedInGB,
        trialEndTime,
        upgradeUrl,
        userCanPay
    ]);
    if (!showModal || !trialEndDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "jiraLossAversionStorage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cni0k.Modal), {
        width: 488,
        title: formatMessage(isUrgent ? (0, $29rFz.default).urgentHeading : (0, $29rFz.default).nonUrgentHeading),
        subtitle: formatMessage(userCanPay ? (0, $29rFz.default).adminSubheading : (0, $29rFz.default).nonAdminSubheading, {
            formattedDate: trialEndDate
        }),
        onClose: onClose,
        testId: "loss-aversion.ui.loss-aversion-modal.storage",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            onClick: onClose,
            appearance: "subtle"
        }, formatMessage(userCanPay ? (0, $29rFz.default).maybeLater : (0, $29rFz.default).close)), userCanPay && addPaymentDetailsUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
            onClick: onAddPaymentDetails,
            href: addPaymentDetailsUrl,
            appearance: "primary",
            target: "_blank"
        }, formatMessage((0, $29rFz.default).addPayment)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ba995786e4465c50$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fyE0l.StorageLimits), {
        title: formatMessage((0, $29rFz.default).usedStorageHeading, {
            storageUsed: storageUsedInGB.toFixed(0)
        }),
        description: formatMessage((0, $29rFz.default).usedStorageSubheading),
        ariaLabel: `${storageUsedInGB.toFixed(0)} GB of 250 GB (over free limit of 2 GB)`,
        used: storageUsedInGB,
        limit: 250,
        baseLimit: {
            title: 'Free limit',
            limit: 2
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            experiment: (0, $d08b9e75af3069cb$export$855e843fe464d553)
        }
    }));
};
const $ba995786e4465c50$var$boxStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
    padding: 'space.300',
    borderRadius: '4.2px',
    paddingBottom: 'space.600'
});

});
parcelRegister("fyE0l", function(module, exports) {

$parcel$export(module.exports, "StorageLimits", () => $b45ffa5747bdc490$export$ca644461e233232);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $kUbD2 = parcelRequire("kUbD2");
const $b45ffa5747bdc490$export$ca644461e233232 = ({ title: title, description: description, used: used, limit: limit, ariaLabel: ariaLabel, baseLimit: baseLimit })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "small",
        color: "color.text.subtlest"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUbD2.ProgressBar), {
        value: used / limit,
        ariaLabel: ariaLabel,
        baseLimit: baseLimit,
        limit: limit
    }));
};

});
parcelRegister("kUbD2", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", () => $183ff5a07b0df0aa$export$c17561cb55d4db30);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");
const $183ff5a07b0df0aa$var$MIN_VALUE = 0;
const $183ff5a07b0df0aa$var$MAX_VALUE = 1;
const $183ff5a07b0df0aa$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '12px',
    width: '100%',
    borderRadius: 'border.radius.circle',
    position: 'relative'
});
const $183ff5a07b0df0aa$var$barStyles = (0, $1ZAYh.xcss)({
    minWidth: '12px',
    height: '12px',
    borderRadius: 'border.radius.circle'
});
const $183ff5a07b0df0aa$var$baseBarStyles = (0, $1ZAYh.xcss)({
    minWidth: '12px',
    height: '12px',
    borderTopLeftRadius: 'border.radius.circle',
    borderBottomLeftRadius: 'border.radius.circle',
    backgroundColor: 'color.background.accent.purple.subtle',
    position: 'absolute',
    top: 'space.0',
    left: 'space.0',
    borderRightWidth: 'border.width.outline',
    borderRightStyle: 'solid',
    borderRightColor: 'color.border.inverse'
});
const $183ff5a07b0df0aa$var$baseTextStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    minWidth: '12px',
    marginLeft: 'space.150',
    position: 'relative',
    '::after': {
        borderLeftWidth: 'border.width.outline',
        borderLeftStyle: 'dotted',
        borderLeftColor: 'color.border.discovery',
        position: 'absolute',
        top: '0',
        left: '-2px',
        content: '""',
        display: 'block',
        width: '1px',
        height: '16px'
    }
});
const $183ff5a07b0df0aa$export$c17561cb55d4db30 = ({ value: value, ariaLabel: ariaLabel, baseLimit: baseLimit, limit: limit })=>{
    // Handle instances where we're passed 140% for overages
    const amount = Math.max($183ff5a07b0df0aa$var$MIN_VALUE, Math.min(value, $183ff5a07b0df0aa$var$MAX_VALUE));
    const backgroundColor = (0, $eUqFw.useMemo)(()=>{
        if (baseLimit !== undefined) return 'color.background.accent.blue.bolder';
        if (amount >= 0.9) return 'color.background.danger.bold';
        if (amount >= 0.7) return 'color.background.warning.bold';
        return 'color.background.accent.blue.bolder';
    }, [
        amount,
        baseLimit
    ]);
    if (baseLimit !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        backgroundColor: 'color.background.input',
        xcss: $183ff5a07b0df0aa$var$containerStyles,
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $183ff5a07b0df0aa$var$MIN_VALUE,
        "aria-valuenow": amount,
        "aria-valuemax": $183ff5a07b0df0aa$var$MAX_VALUE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        backgroundColor: backgroundColor,
        style: {
            width: `${Number(amount) * 100}%`
        },
        xcss: $183ff5a07b0df0aa$var$barStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        style: {
            width: `${Number(baseLimit.limit / limit) * 100}%`
        },
        xcss: $183ff5a07b0df0aa$var$baseBarStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        style: {
            paddingLeft: `${Number(baseLimit.limit / limit) * 100}%`
        },
        xcss: $183ff5a07b0df0aa$var$baseTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "small",
        weight: "medium",
        color: "color.text.discovery"
    }, baseLimit.title))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        backgroundColor: 'color.background.accent.gray.subtlest',
        xcss: $183ff5a07b0df0aa$var$containerStyles,
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $183ff5a07b0df0aa$var$MIN_VALUE,
        "aria-valuenow": amount,
        "aria-valuemax": $183ff5a07b0df0aa$var$MAX_VALUE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        backgroundColor: backgroundColor,
        style: {
            width: `${Number(amount) * 100}%`
        },
        xcss: $183ff5a07b0df0aa$var$barStyles
    }));
};

});


parcelRegister("29rFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $837181d31923fe7f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $837181d31923fe7f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    urgentHeading: {
        "id": "loss-aversion.loss-aversion-modal.storage.urgent-heading",
        "defaultMessage": "Don\u2019t lose access to extra storage "
    },
    nonUrgentHeading: {
        "id": "loss-aversion.loss-aversion-modal.storage.non-urgent-heading",
        "defaultMessage": "Keep using 250 GB of storage"
    },
    adminSubheading: {
        "id": "loss-aversion.loss-aversion-modal.storage.admin-subheading",
        "defaultMessage": "Your Standard trial ends on {formattedDate}. Add payment to keep uploading files and images."
    },
    nonAdminSubheading: {
        "id": "loss-aversion.loss-aversion-modal.storage.non-admin-subheading",
        "defaultMessage": "Ask your admin to purchase Jira Standard for your team. Your trial ends on {formattedDate}."
    },
    addPayment: {
        "id": "loss-aversion.loss-aversion-modal.storage.add-payment",
        "defaultMessage": "Add payment"
    },
    maybeLater: {
        "id": "loss-aversion.loss-aversion-modal.storage.maybe-later",
        "defaultMessage": "Maybe later"
    },
    close: {
        "id": "loss-aversion.loss-aversion-modal.storage.close",
        "defaultMessage": "Close"
    },
    usedStorageHeading: {
        "id": "loss-aversion.loss-aversion-modal.storage.used-storage-heading",
        "defaultMessage": "{storageUsed} out of 250 GB used"
    },
    usedStorageSubheading: {
        "id": "loss-aversion.loss-aversion-modal.storage.used-storage-subheading",
        "defaultMessage": "Your team is over the Free plan\u2019s limit of 2 GB"
    }
});

});


parcelRegister("ltinT", function(module, exports) {

$parcel$export(module.exports, "UserLimitModal", () => $c822461c9c14ec4f$export$c6f94866be4fd825);

var $4gfBs = parcelRequire("4gfBs");

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $iWLL0 = parcelRequire("iWLL0");

var $bFzGY = parcelRequire("bFzGY");

var $6zOB7 = parcelRequire("6zOB7");
var $fI650 = parcelRequire("fI650");

var $4kMup = parcelRequire("4kMup");
var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cni0k = parcelRequire("cni0k");

var $hgOsY = parcelRequire("hgOsY");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");

var $dWLk9 = parcelRequire("dWLk9");

var $2y8KF = parcelRequire("2y8KF");


var $9Z2je = parcelRequire("9Z2je");
var $2pc1v = parcelRequire("2pc1v");

var $iDxxA = parcelRequire("iDxxA");
const $c822461c9c14ec4f$export$c6f94866be4fd825 = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl, userCount: userCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "userLimitModal",
        packageName: "jiraLossAversion",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c822461c9c14ec4f$export$ec23fbe1e263ce95, {
        userCount: userCount,
        userCanPay: userCanPay,
        upgradeUrl: upgradeUrl
    }));
const $c822461c9c14ec4f$export$ec23fbe1e263ce95 = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl, userCount: userCount })=>{
    const [showModal, setShowModal] = (0, $eUqFw.useState)(true);
    const { isUrgent: isUrgent } = (0, $9Z2je.useExperimentEligibility)((0, $d08b9e75af3069cb$export$855e843fe464d553));
    const onClose = ()=>setShowModal(false);
    const { trialEndTime: trialEndTime, trialDaysLeft: trialDaysLeft } = (0, $2pc1v.useTrialDetails)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5JgJ2.default)();
    const [userAvatars, setUserAvatars] = (0, $eUqFw.useState)();
    const [loadingAvatars, setLoadingAvatars] = (0, $eUqFw.useState)(true);
    const [avatarsError, setAvatarsError] = (0, $eUqFw.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const trialEndDate = trialEndTime && formatDate(new Date(trialEndTime), {
        day: 'numeric',
        month: 'long'
    });
    const cloudId = (0, $dWLk9.useCloudId)();
    const addPaymentUrl = upgradeUrl || `https://admin.atlassian.com/billing/${cloudId}/payment-methods`;
    const origin = new (0, $jkH4Q.default)({
        product: 'jira'
    });
    const addPaymentDetailsUrl = origin.addToUrl(addPaymentUrl);
    const REMOVE_USERS_LINK = '/admin/users?referrerName=JIRA';
    const data = (0, $iWLL0.useLazyLoadQuery)((0, $4gfBs.default), {
        cloudId: cloudId
    });
    const projectKeys = (0, $eUqFw.useMemo)(()=>data?.jira?.allJiraProjects?.edges?.map((edge)=>edge?.node?.key) || [], [
        data
    ]);
    const onAddPaymentDetails = (0, $eUqFw.useCallback)(()=>{
        (0, $2y8KF.fireButtonAnalytics)(createAnalyticsEvent, 'jlaAddPaymentButton', {
            trialDaysLeft: trialDaysLeft,
            userCanPay: userCanPay,
            modal: 'jlaUserModal'
        });
        setShowModal(false);
    }, [
        createAnalyticsEvent,
        trialDaysLeft,
        userCanPay
    ]);
    const onRemoveUsers = (0, $eUqFw.useCallback)(()=>{
        (0, $2y8KF.fireButtonAnalytics)(createAnalyticsEvent, 'jlaRemoveUsers', {
            trialDaysLeft: trialDaysLeft,
            userCanPay: userCanPay,
            modal: 'jlaUserModal'
        });
    }, [
        createAnalyticsEvent,
        trialDaysLeft,
        userCanPay
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const usersResponse = await (0, $lRmyA.performGetRequestWithRetry)(`/rest/api/3/user/assignable/multiProjectSearch?projectKeys=${projectKeys.join(',')}&maxResults=100`);
                const userData = usersResponse?.map((user)=>({
                        key: user.emailAddress || '',
                        name: user.displayName || '',
                        src: user.avatarUrls['48x48']
                    }));
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetched userAvatars', {});
                setUserAvatars(userData);
                setShowModal(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'fetchUserAvatarsWithRetry',
                        packageName: 'jiraLossAversion'
                    }
                });
                setAvatarsError(error.message || 'Unknown avatar fetch error');
            } finally{
                setLoadingAvatars(false);
            }
        };
        fetchData();
    }, [
        projectKeys,
        createAnalyticsEvent,
        trialDaysLeft,
        userCanPay
    ]);
    const getSubTitleText = (0, $eUqFw.useCallback)(()=>{
        if (userCanPay) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...isUrgent ? (0, $iDxxA.default).jswStandardUserModalSubTitleUrgent : (0, $iDxxA.default).jswStandardUserModalSubTitle,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
                        href: REMOVE_USERS_LINK,
                        onClick: onRemoveUsers,
                        target: "_blank"
                    }, chunks),
                trialEndDate: trialEndDate
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...isUrgent ? (0, $iDxxA.default).jswStandardUserModalSubTitleNoPayUrgent : (0, $iDxxA.default).jswStandardUserModalSubTitleNoPay,
            values: {
                trialEndDate: trialEndDate
            }
        });
    }, [
        isUrgent,
        trialEndDate,
        userCanPay,
        onRemoveUsers
    ]);
    const getTitleText = (0, $eUqFw.useCallback)(()=>{
        if (isUrgent) return formatMessage((0, $iDxxA.default).jswStandardUserModalTitleUrgent);
        if (userCanPay) return formatMessage((0, $iDxxA.default).jswStandardUserModalTitle);
        return formatMessage((0, $iDxxA.default).jswStandardUserModalTitleNoPay);
    }, [
        formatMessage,
        isUrgent,
        userCanPay
    ]);
    if (!showModal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c822461c9c14ec4f$var$modalStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "jiraLossAversionUser"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cni0k.Modal), {
        width: 488,
        title: getTitleText(),
        subtitle: getSubTitleText(),
        onClose: onClose,
        testId: "loss-aversion.ui.loss-aversion-modal.user-limit",
        actions: userCanPay && addPaymentDetailsUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            onClick: onClose,
            appearance: "subtle"
        }, formatMessage((0, $iDxxA.default).jswStandardSecondaryCtaText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
            onClick: onAddPaymentDetails,
            appearance: "primary",
            href: addPaymentDetailsUrl,
            target: "_blank"
        }, formatMessage((0, $iDxxA.default).jswStandardPrimaryCtaText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            onClick: onClose,
            appearance: "subtle"
        }, formatMessage((0, $iDxxA.default).jswStandardPrimaryCtaTextNoPay))
    }, !loadingAvatars && !avatarsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c822461c9c14ec4f$var$userAvatarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgOsY.UserLimits), {
        dividerLimit: 10,
        assignedUsers: userAvatars || userCount,
        limit: 10,
        title: formatMessage((0, $iDxxA.default).jswStandardUserAvatarTitle, {
            userCount: userCount
        }),
        description: formatMessage((0, $iDxxA.default).jswStandardUserAvatarSubTitle)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            experiment: (0, $d08b9e75af3069cb$export$855e843fe464d553),
            trialDaysLeft: trialDaysLeft,
            userCanPay: userCanPay
        }
    })));
};
const $c822461c9c14ec4f$var$userAvatarStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    padding: 'space.300',
    maxWidth: '400px',
    flexDirection: 'column',
    borderRadius: '4.2px',
    gap: 'space.150',
    backgroundColor: 'color.background.accent.gray.subtlest'
});
const $c822461c9c14ec4f$var$modalStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    maxWidth: '499px',
    gap: 'space.0',
    flex: '1 0 0'
});

});
parcelRegister("4gfBs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ec18bae0db026e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<73eef4e04fd8c30eb8d15c6dc07a4de8>>
 * @relayHash ad8882ecb6670359b684202c34cd11f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f01d2dcbf15026d7e29e8dee47801496827b165db2e83daea189e41c6bab8c1a
const $7ec18bae0db026e7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "sortBy": {
                    "order": "ASC",
                    "sortBy": "KEY"
                },
                "types": "SOFTWARE"
            }
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "userLimitModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "userLimitModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f01d2dcbf15026d7e29e8dee47801496827b165db2e83daea189e41c6bab8c1a",
            "metadata": {},
            "name": "userLimitModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7ec18bae0db026e7$var$node.hash = "bbcd803edbb82700dc92e521570b35eb";
var $7ec18bae0db026e7$export$2e2bcd8739ae039 = $7ec18bae0db026e7$var$node;

});

parcelRegister("hgOsY", function(module, exports) {

$parcel$export(module.exports, "UserLimits", () => $61058eb459c5479b$export$4954b8bb56ebcd48);

var $eUqFw = parcelRequire("eUqFw");

var $4XQdE = parcelRequire("4XQdE");

var $hI5oG = parcelRequire("hI5oG");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $4q38b = parcelRequire("4q38b");

var $8hjiy = parcelRequire("8hjiy");

var $6knFa = parcelRequire("6knFa");

var $kLsz7 = parcelRequire("kLsz7");

var $bIkoV = parcelRequire("bIkoV");

var $2ouZT = parcelRequire("2ouZT");
const $61058eb459c5479b$var$EMPTY_AVATAR = {
    key: '',
    name: ''
};
const $61058eb459c5479b$var$dividerStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.150',
    marginLeft: 'space.075',
    height: 'space.500'
});
const $61058eb459c5479b$export$4954b8bb56ebcd48 = ({ title: title, description: description, assignedUsers: assignedUsers, limit: limit, size: size, dividerLimit: dividerLimit })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const avatars = (0, $eUqFw.useMemo)(()=>{
        const usedAvatarSrc = colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($8hjiy))) : (0, (/*@__PURE__*/$parcel$interopDefault($6knFa)));
        const unusedAvatarSrc = colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($bIkoV))) : (0, (/*@__PURE__*/$parcel$interopDefault($2ouZT)));
        const usedAvatar = {
            ...$61058eb459c5479b$var$EMPTY_AVATAR,
            src: usedAvatarSrc
        };
        const unusedAvatar = {
            ...$61058eb459c5479b$var$EMPTY_AVATAR,
            src: unusedAvatarSrc
        };
        if (!Array.isArray(assignedUsers)) {
            const usedAvatars = new Array(assignedUsers).fill(usedAvatar);
            const unusedAvatars = limit && limit - assignedUsers > 0 ? new Array(limit - assignedUsers).fill(unusedAvatar) : [];
            return [
                ...usedAvatars,
                ...unusedAvatars
            ];
        }
        if (limit === undefined || assignedUsers.length >= limit) // No limit, just return the assigned users
        return assignedUsers;
        const dummyAvatars = new Array(limit - assignedUsers.length).fill(unusedAvatar);
        return [
            ...assignedUsers,
            ...dummyAvatars
        ];
    }, [
        assignedUsers,
        limit,
        colorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "small",
        color: "color.text.subtlest"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center"
    }, dividerLimit !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: avatars,
        maxCount: dividerLimit + 1,
        size: size ?? 'medium',
        overrides: {
            Avatar: {
                render: (Component, props, index)=>index === dividerLimit - 1 && avatars.length > dividerLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                        ...props,
                        key: index
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        xcss: $61058eb459c5479b$var$dividerStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($kLsz7))),
                        alt: "Simple example",
                        testId: "image"
                    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                        ...props,
                        key: index
                    })
            }
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: avatars,
        maxCount: 11,
        size: size ?? 'medium'
    })));
};

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`}`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';


parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("8hjiy", function(module, exports) {
module.exports = new URL("user-brand-dark.53b470c6.svg", import.meta.url).toString();

});

parcelRegister("6knFa", function(module, exports) {
module.exports = new URL("user-brand-light.00eefa28.svg", import.meta.url).toString();

});

parcelRegister("kLsz7", function(module, exports) {
module.exports = new URL("user-divider.cbebe2f3.svg", import.meta.url).toString();

});

parcelRegister("bIkoV", function(module, exports) {
module.exports = new URL("user-gray-dark.f2ef58b1.svg", import.meta.url).toString();

});

parcelRegister("2ouZT", function(module, exports) {
module.exports = new URL("user-gray-light.b6caaf13.svg", import.meta.url).toString();

});


parcelRegister("iDxxA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fbafe8c8a845695$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3fbafe8c8a845695$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jswStandardUserModalTitleUrgent: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title-urgent",
        "defaultMessage": "Don\u2019t lose access to unlimited users"
    },
    jswStandardUserModalSubTitleUrgent: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title-urgent",
        "defaultMessage": "Your Standard trial ends on {trialEndDate}. Add payment or <a>remove users</a> to avoid deactivation."
    },
    jswStandardUserModalRemoveUsersLinkText: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-remove-users-link-text",
        "defaultMessage": "remove users"
    },
    jswStandardUserModalTitle: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title",
        "defaultMessage": "Keep adding your entire team"
    },
    jswStandardUserModalTitleNoPay: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title-no-pay",
        "defaultMessage": "Keep working with your entire team"
    },
    jswStandardUserModalSubTitle: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title",
        "defaultMessage": "Your Standard trial ends on {trialEndDate}. Add payment or <a>remove users</a> to avoid deactivation."
    },
    jswStandardUserModalTitleNoPayUrgent: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title-no-pay-urgent",
        "defaultMessage": "Ask your admin to add payment for Jira Standard. Your trial ends on {trialEndDate}."
    },
    jswStandardUserModalSubTitleNoPayUrgent: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title-no-pay-urgent",
        "defaultMessage": "Ask your admin to add payment for Jira Standard. Your trial ends on {trialEndDate}"
    },
    jswStandardUserModalSubTitleNoPay: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title-no-pay",
        "defaultMessage": "Ask your admin to add payment for Jira Standard, so you can keep unlimited users. Your trial ends on {trialEndDate}."
    },
    jswStandardPrimaryCtaText: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-primary-cta-text",
        "defaultMessage": "Add payment"
    },
    jswStandardPrimaryCtaTextNoPay: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-primary-cta-text-no-pay",
        "defaultMessage": "Close"
    },
    jswStandardSecondaryCtaText: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-secondary-cta-text",
        "defaultMessage": "Maybe later"
    },
    jswStandardUserAvatarTitle: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-avatar-title",
        "defaultMessage": "{userCount} people added"
    },
    jswStandardUserAvatarSubTitle: {
        "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-avatar-sub-title",
        "defaultMessage": "Your team is over the Free plan\u2019s limit of 10 users"
    }
});

});






//# sourceMappingURL=async-jira-loss-aversion-modal-feature.d9e0b6cd.js.map
